// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.skeleton-loader[data-v-5f5114f0] {
  position: relative;
  overflow: hidden;
  background-color: var(--skeleton-base-color, rgba(0, 0, 0, 0.06));
  border-radius: 4px;
}
.skeleton-loader[data-v-5f5114f0]::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.2) 20%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0)
  );
  animation: shimmer-5f5114f0 2s infinite;
  content: '';
}
@keyframes shimmer-5f5114f0 {
100% {
    transform: translateX(100%);
}
}
:root[data-theme="dark"] .skeleton-loader[data-v-5f5114f0] {
  --skeleton-base-color: rgba(255, 255, 255, 0.04);
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
